import { supabase } from "@/integrations/supabase/client";
import { setSettingIntFn, setSettingTextFn } from "@/lib/app-settings.functions";

export const SETTING_COMMUNITY_MAX_IMAGES = "community_max_images_per_submission";
export const SETTING_PHOTOGRAPHER_MAX_GALLERY = "photographer_max_gallery_images";
export const SETTING_VISAGIST_MAX_GALLERY = "visagist_max_gallery_images";
export const SETTING_WATERMARK_URL = "community_watermark_url";
export const SETTING_WATERMARK_X = "community_watermark_x"; // percent (0-100)
export const SETTING_WATERMARK_Y = "community_watermark_y"; // percent (0-100)
export const SETTING_WATERMARK_SCALE = "community_watermark_scale"; // percent of image width (1-100)
export const SETTING_WATERMARK_OPACITY = "community_watermark_opacity"; // percent (0-100)

// Link-Vorschau (Open Graph) Einstellungen
export const SETTING_OG_HOME_IMAGE = "og_home_image_url"; // Startseite: feste Vorschau-URL (leer = Automatik)
export const SETTING_OG_GLOBAL_IMAGE = "og_global_image_url"; // Globaler Standard für übrige Seiten (leer = og-cover)
// Texte für die generierte Vorlage
export const SETTING_OG_HOME_TITLE = "og_home_title";
export const SETTING_OG_HOME_SUBTITLE = "og_home_subtitle";
export const SETTING_OG_HOME_DESC = "og_home_desc";
export const SETTING_OG_GLOBAL_TITLE = "og_global_title";
export const SETTING_OG_GLOBAL_SUBTITLE = "og_global_subtitle";
export const SETTING_OG_GLOBAL_DESC = "og_global_desc";
// Original-Bildquelle + Fokuspunkt (für verschiebbaren Ausschnitt)
export const SETTING_OG_HOME_SRC = "og_home_src_url";
export const SETTING_OG_GLOBAL_SRC = "og_global_src_url";
export const SETTING_OG_HOME_FOCUS = "og_home_focus"; // "focusX,focusY,natW,natH"
export const SETTING_OG_GLOBAL_FOCUS = "og_global_focus";

export async function getSettingInt(key: string, fallback: number): Promise<number> {
  const { data, error } = await supabase
    .from("app_settings_public" as never)
    .select("value_int")
    .eq("key", key)
    .maybeSingle() as { data: { value_int: number | null } | null; error: unknown };
  if (error || !data || data.value_int == null) return fallback;
  return data.value_int;
}

export async function setSettingInt(key: string, value: number): Promise<void> {
  await setSettingIntFn({ data: { key, value } });
}

export async function getSettingText(key: string, fallback: string | null = null): Promise<string | null> {
  const { data, error } = await supabase
    .from("app_settings_public" as never)
    .select("value_text")
    .eq("key", key)
    .maybeSingle() as { data: { value_text: string | null } | null; error: unknown };
  if (error || !data || data.value_text == null) return fallback;
  return data.value_text;
}

export async function setSettingText(key: string, value: string | null): Promise<void> {
  await setSettingTextFn({ data: { key, value } });
}